import React, { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, Label, AlertBar } from 'scorer-ui-kit';
import styled from 'styled-components';
import { BoxContainer } from '../components/BoxContainer';
import { FieldContainer, LeftButton, RightAlignedContainer } from '../Style';
import { updateDevice } from '../apis';

const AlertContainer = styled.div`
  width: 500px;
`;

interface Props {
  period: number,
  setLogPeriod: (period: number) => void
}
function LogSettingsTab({ period, setLogPeriod }: Props) {
  const [readOnly, setReadOnly] = useState(true);
  const [retentionPeriod, setRetentionPeriod] = useState<any>(period);
  const [alert, setAlert] = useState<{ key: any, message: string, type: 'success' | 'error' | 'warning' | 'info' | undefined }>({ key: new Date(), message: '', type: undefined });

  const { t } = useTranslation(['AuditLogs', 'Common']);

  useEffect(() => {
    setRetentionPeriod(period);
  }, [period]);

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.persist();
    let regEx = /^[0-9][0-9]*$/;
    if (regEx.exec(event.target.value)) {
      setRetentionPeriod(parseInt(event.target.value))
    } else {
      if (event.target.value === '') {
        setRetentionPeriod('');
      }
    }
  };

  const onEdit = () => {
    setReadOnly(false);
  };

  const onSave = () => {
    if (!Number.isInteger(retentionPeriod) || !retentionPeriod.toString().trim().length) {
      setAlert({ key: new Date(), message: t('logSettingsTab.pleaseEnterValidRetentionPeriod'), type: 'error' });
      return;
    }
    if(retentionPeriod <= 0){
      setAlert({ key: new Date(), message: t('logSettingsTab.retentionPeriodShouldBeGreaterThanZero'), type: 'error' });
      return;
    }
    
    const jsonData = { action: 'set_retention', data: { audit_keep_days: parseInt(retentionPeriod) } };
    updateDevice(jsonData)
      .then((res) => {
        if (res.data.status_code === '0') {
          setAlert({ key: new Date(), message: t('logSettingsTab.retentionPeriodUpdatedSuccessfully'), type: 'success' });
          setReadOnly(true);
          setLogPeriod(parseInt(retentionPeriod));
        } else {
          setAlert({ key: new Date(), message: res.data.message, type: 'error' });
          setReadOnly(false);
        }
      })
      .catch((err) => {
        if (err.response.data.message) {
          setAlert({ key: new Date(), message: err.response.data.message, type: 'error' });
        }
        console.error(err);
      });
    setReadOnly(true);
  };

  const onCancel = () => {
    setReadOnly(true);
    setRetentionPeriod(period);
  };

  return (
    <>
      <BoxContainer title=''>
        <FieldContainer>
          <Label htmlFor='retention_period' labelText={t('logSettingsTab.retentionPeriod')} />
          <Input type='number' name='retention_period' placeholder={t('logSettingsTab.enterDays')} value={retentionPeriod} onChange={onInputChange} readOnly={readOnly} required/>
        </FieldContainer>

        <RightAlignedContainer>
          {
            readOnly ?
              <Button design='primary' onClick={onEdit}>{t('Common:edit')}</Button> :
              <>
                <LeftButton design='secondary' onClick={onCancel}>{t('Common:cancel')}</LeftButton>
                <Button design='primary' onClick={onSave}>{t('Common:save')}</Button>
              </>

          }
        </RightAlignedContainer>
      </BoxContainer>
      {
        (alert.message !== '' &&
          <AlertContainer key={alert.key}>
            <AlertBar type={alert.type} message={alert.message} />
          </AlertContainer>
        )
      }
    </>
  );
}

export default LogSettingsTab;